import React from 'react';

import lang from '../../../../lib/language';

import styles from './PlanDetailsTable.module.scss';

interface PlanStage {
  name: string;
  buyingPower: string;
  profitShare: string;
  profitTarget: string;
  maxDrawdown: string;
  maxDailyLoss: string;
  minTradingDays: string;
  consistencyRule: string;
  riskManagementRule: string;
}

interface PlanDetailsTableProps {
  planStages: PlanStage[];
}

const PlanDetailsTable: React.FC<PlanDetailsTableProps> = ({ planStages }) => {
  const PlanDetailsRow = (title: string, fieldName: keyof PlanStage) => (
    <div className={styles.tableRow}>
      <div className={styles.tableLabelCell}>{title}</div>
      {/* eslint-disable-next-line */}
    {planStages.map((stage) => (
      <div key={stage.name} className={styles.tableDataCell}>{stage[fieldName]}</div>
    ))}
    </div>
  );

  return (
    <div className={styles.tableContainer}>
      <div className={styles.table}>
        {/* Header Row */}
        <div className={styles.tableHeaderRow}>
          <div className={styles.tableHeaderCell}>{lang.rules()}</div>
          {planStages.map((stage) => (
            <div key={stage.name} className={styles.tableHeaderCell}>{stage.name}</div>
          ))}
        </div>

        {PlanDetailsRow(lang.buyingPower(), 'buyingPower')}
        {PlanDetailsRow(lang.profitShare(), 'profitShare')}
        {PlanDetailsRow(lang.profitTarget(), 'profitTarget')}
        {PlanDetailsRow(lang.maxDrawdown(), 'maxDrawdown')}
        {PlanDetailsRow(lang.maxDailyLoss(), 'maxDailyLoss')}
        {PlanDetailsRow(lang.minTradingDays(), 'minTradingDays')}
        {PlanDetailsRow(lang.consistencyRule(), 'consistencyRule')}
        {PlanDetailsRow(lang.riskManagementRule(), 'riskManagementRule')}
      </div>
    </div>
  );
};

export default PlanDetailsTable;
